<template>
  <div v-if="!loading">
    <div v-if="(result.shortUrlType == 'ExternalToMiniprogram' && result.remark)">
      <div class="dialog"></div>
      <div class="dialog_box">
        <h4>免责声明</h4>
        <div class="content">{{ result.remark }}</div>
        <div class="btn" @click="bocLunch">我知道了</div>
      </div>
    </div>
    <div class="flex-center" v-if="authHref">
      <div>
        <h3>小提示</h3>
        <p>本活动需要您授权登录后即可进入哦~</p>
        <a class="btn-auth" :href="authHref" target="_blank">点击登录</a>
      </div>
    </div>
  </div>
</template>
<script>
import { createUniqueString } from '@/utils/index'
export default {
  data() {
    return {
      Base_Url: "",
      shortUrlId: "",
      sessionId: "",
      wxCode: '',
      result: "",
      externalChannelCode: '',
      loading: false,
      appId: '',
      authHref: ''
    };
  },
  mounted() {
    document.title = '跳转中...'
    this.Base_Url = Config.VUE_APP_BASE_API || process.env.VUE_APP_BASE_API;
    this.shortUrlId = this.$route.params.id;
    this.externalChannelCode = this.$route.params.code;
    this.wxCode = this.$route.query.code
    if (localStorage.getItem('sessionId')) {
      this.sessionId = localStorage.getItem('sessionId');
    }
    else {
      this.sessionId = createUniqueString();
      localStorage.setItem('sessionId', this.sessionId);
    }
    // this.addRecordLog()
    this.buildByShortUrlId();
    this.initWindow()
  },
  methods: {
    initWindow() {
      window.terminal = (function () {
        var u = navigator.userAgent;
        return {
          trident: u.indexOf('Trident') > -1,
          presto: u.indexOf('Presto') > -1,
          webKit: u.indexOf('AppleWebKit') > -1,
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') > -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
          iPhone: u.indexOf('iPhone') > -1,
          iPad: u.indexOf('iPad') > -1,
          webApp: u.indexOf('Safari') > -1,
          weixin: u.indexOf('MicroMessenger') > -1 && u.replace(/.*(MicroMessenger\/[^\s]*).*/, "$1").replace("MicroMessenger/", "") || false,
          bocapp: u.indexOf('bocapp(') > -1,
          appVersion: u.indexOf('bocapp(') > -1 ? u.match(/bocapp\(\S+\)/)[0].slice(7, -1) : '3.0.0'
        };
      })()
      if (window.terminal.bocapp) {
        var script = document.createElement('script')
        var pth = "https://ebsnew.boc.cn/bocphone/BocMerchant/"
        if (window.terminal.iPhone) {
          script.src = pth + 'paylib/ios.js'
        } else if (window.terminal.android) {
          script.src = pth + 'paylib/android.js'
        }
        document.getElementsByTagName('head')[0].appendChild(script)
      }
    },
    goMiniApp(appid, path) {
      document.addEventListener('deviceready', () => {
        window.c_plugins.merchantBridge.weixinOpenMiniProgram(() => { }, function (err) { console.log(err) }, { userName: appid, path: path })
      })
    },
    bocLunch() {
      this.goMiniApp(this.result.appUserName, this.result.url);
    },
    buildByShortUrlId() {
      let data = {
        sessionId: this.sessionId,
        shortUrlId: this.shortUrlId
      };
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/url/buildByShortUrlId",
        method: "post",
        data
      }).then((res) => {
        const result = res.data.data
        this.result = result
        const APPID = result.appId
        this.appId = APPID
        if (!result.externalChannelCode || !this.externalChannelCode || (result.externalChannelCode.toLowerCase() != this.externalChannelCode.toLowerCase())) {
          this.loading = true
          window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=非法渠道");
          return
        }
        if (result.shortUrlType == "ExternalToMiniprogram") {
          if (!result.remark) this.bocLunch()
        } else {
          if (result.shortUrlType == "H5" && (result.identifyUser == 1 || result.identifyUser == 2)) {
            if (!this.wxCode) {
              if (result.identifyUser == 1) {
                const redirect_url = location.href//encodeURIComponent(location.href)
                const scope = 'snsapi_userinfo' || 'snsapi_base'
                // const component_appid = result.componentAppId
                this.$axios({
                  url: this.Base_Url + "mkt/unAuthenticate/app/buildAuthorizationUrl",
                  method: "get",
                  params: {
                    appId: APPID,
                    redirectUri: redirect_url,
                    scope,
                    state: 'short_link'
                  },
                }).then(({ data }) => {
                  location.replace(data.data)
                }).catch(err => {
                  let msg = null;
                  if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message
                  }
                  else {
                    msg = "很抱歉，授权异常"
                  }
                  window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
                })
              }
              if (result.identifyUser == 2) {
                const redirect_url = location.href//encodeURIComponent(location.href)
                const scope = 'snsapi_userinfo' || 'snsapi_base'
                // const component_appid = result.componentAppId
                let hasAppId = localStorage.getItem('short_link_' + APPID)
                if (hasAppId) {
                  if (new Date() > new Date(hasAppId)) {
                    hasAppId = ''
                  }
                }
                this.$axios({
                  url: this.Base_Url + "mkt/unAuthenticate/app/buildAuthorizationUrl",
                  method: "get",
                  params: {
                    appId: APPID,
                    redirectUri: redirect_url,
                    scope,
                    state: 'short_link'
                  },
                }).then(({ data }) => {
                  if (hasAppId) {
                    location.replace(data.data)
                  } else {
                    this.authHref = data.data
                  }
                }).catch(err => {
                  let msg = null;
                  if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message
                  }
                  else {
                    msg = "很抱歉，授权异常"
                  }
                  window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
                })
              }
              // const authURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirect_url}&response_type=code&scope=${scope}&state=&component_appid=${component_appid}#wechat_redirect`
              return
            }
            this.getUserInfo()
          }
          setTimeout(() => {
            window.location.href = result.url;
          }, 300);
        }
      }).catch(err => {
        let msg = null;
        if (err.response && err.response.data && err.response.data.message) {
          msg = err.response.data.message
        }
        else {
          msg = "很抱歉，链接已失效"
        }
        window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
      })
    },
    handleAuth() {
      location.href = this.authHref
    },
    getUserInfo() {
      if (this.appId) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 30);
        localStorage.setItem('short_link_' + this.appId, currentDate)
      }
      const jsonData = {
        sessionId: this.sessionId,
        shortUrlId: this.shortUrlId,
        code: this.wxCode
      }
      const query = this.$route.query
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/url/identifyUser",
        method: "post",
        data: jsonData,
        params: {
          ...query
        }
      })
    },
    addRecordLog() {
      this.$axios({
        url: this.Base_Url + "mkt/unAuthenticate/app/frontEventRecord",
        method: "get",
        params: {
          page: location.href,
          value: this.sessionId,
        },
      })
    }
  }
};
</script>
<style lang='scss'>
.jump_reload {
  border: 1px solid;
  margin: 60px auto;
  width: 200px;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  opacity: 0.5;
  background: #000;
  z-index: 1;
}

.dialog_box {
  background: #fff;
  position: absolute;
  z-index: 2;
  border-radius: 5px;
  top: calc((100vh - 260px) / 2);
  min-height: 160px;
  width: calc(86% - 20px);
  left: 7%;
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h4 {
    margin: 0 30px;
    padding: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #dddddd;
  }

  .content {
    text-align: left;
    font-size: 14px;
    padding: 0 10px;
    line-height: 22px;
  }

  .btn {
    font-size: 15px;
    color: #d4332b;
  }
}

.flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.btn-auth {
  background-color: #2fa62f;
  padding: 10px;
  width: 160px;
  margin: 0 auto;
  color: #fff;
  border-radius: 5px;
  margin-top: 60px;
  display: block;
  text-decoration: none;
}
</style>